// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".restore[data-v-6f3a8b17]{cursor:pointer}.notice-removed[data-v-6f3a8b17]{color:#007600}.notice-error[data-v-6f3a8b17]{color:red}", ""]);
// Exports
module.exports = exports;
